import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FuenteService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getFuente(): Observable<any> {
    return this.http.get(this.baseUrl + 'parFuentes', { headers: this.header(this.token) });
  }

  getFuentesPorTechoId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'listaFuentesXTechoId/'+ id, { headers: this.header(this.token) });
  }

  getFuentesVigentes(): Observable<any> {
    return this.http.get(this.baseUrl + 'parFuentesVigentes', { headers: this.header(this.token) });
  }  

  getFuenteById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parFuente/' + id, { headers: this.header(this.token) });
  }

  postFuente(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'parFuente', bodyString, { headers: this.header(this.token) });
  }

  putFuente(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parFuente', bodyString, { headers: this.header(this.token) });
  }

  deleteFuente(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parFuente/' + id, { headers: this.header(this.token) });
  }
}
